import { ReactElement } from 'react'
import { Box, Stack } from '@mui/material'
import usePlanImageCardTool from '@editor/hooks/usePlanImageCardTool'
import usePlanTableTool from '@editor/hooks/usePlanTableTool'
import { useControlStore } from '@editorStores'
import {
  Toolbar as EditorToolbar,
  StoreyControls,
  CommentToolSelect,
  PlanTableToolSelect,
  PlanImageCardToolSelect,
  useAddCommentTool,
} from '@editorComponents'

const Toolbar = (): ReactElement => {
  const { isActive: isAddCommentActive, toggle: toggleAddComment } = useAddCommentTool()
  const { isActive: isAddPlanTableActive, toggle: toggleAddPlanTable } = usePlanTableTool()
  const { isActive: isAddPlanImageCardActive, toggle: toggleAddPlanImageCard } =
    usePlanImageCardTool()

  const storey = useControlStore(state => state.floorplanState.storey)
  const setFloorplanStorey = useControlStore(state => state.setFloorplanStorey)

  return (
    <>
      <Box
        sx={{
          position: 'absolute',
          top: 0,
          right: 0,
          zIndex: 1,
          pointerEvents: 'none',
        }}
      >
        <Box sx={{ pointerEvents: 'all' }}>
          <StoreyControls storey={storey} setStorey={setFloorplanStorey} />
        </Box>
      </Box>

      <EditorToolbar sx={{ pointerEvents: 'none' }}>
        <Stack direction="row" spacing={0.25} sx={{ pointerEvents: 'all' }}>
          <CommentToolSelect
            isAddCommentActive={isAddCommentActive}
            onToggleAddComment={toggleAddComment}
          />

          <PlanTableToolSelect
            isAddPlanTableActive={isAddPlanTableActive}
            onToggleAddPlanTable={toggleAddPlanTable}
          />

          <PlanImageCardToolSelect
            isAddPlanImageCardActive={isAddPlanImageCardActive}
            onToggleAddPlanImageCard={toggleAddPlanImageCard}
          />
        </Stack>
      </EditorToolbar>
    </>
  )
}

export default Toolbar
